import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatusTone } from '../../Types/status-tone.type';

@Component({
  selector: 'av-status-chip',
  standalone: true,
  imports: [],
  templateUrl: './av-status-chip.component.html',
  styleUrl: './av-status-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-inline-flex' },
})
export class AvStatusChipComponent {
  readonly label = input.required<string>();
  readonly tone = input<StatusTone>('neutral');
}
